import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { getReferralLinkByCode } from '@/utils/api.js';
type ReferralStatus = 'loading' | 'referred' | 'organic';
interface ReferralState {
  status: ReferralStatus;
  refCode: string | null;
}
function normalizeCode(code?: string | null): string | null {
  if (!code) return null;
  const trimmed = code.trim();
  return trimmed.length ? trimmed : null;
}
function buildReferralState(code?: string | null): ReferralState {
  const resolvedCode = normalizeCode(code);
  return resolvedCode ? {
    status: 'referred',
    refCode: resolvedCode
  } : {
    status: 'organic',
    refCode: null
  };
}
async function getValidReferralCode(code?: string | null): Promise<string | null> {
  const resolvedCode = normalizeCode(code);
  if (!resolvedCode) return null;
  try {
    const res = await getReferralLinkByCode(resolvedCode);
    const data = res.data;
    if (data?.id && data.status === 'active') {
      return resolvedCode;
    }
  } catch {
    return null;
  }
  return null;
}
function useReferral(code) {
  const $ = _c(2);
  const router = useRouter();
  const rawCode = router.isReady ? router.query.code || router.query.ref : undefined;
  const queryCode = Array.isArray(rawCode) ? rawCode[0] : rawCode;
  const resolvedCode = code || queryCode;
  let t0;
  if ($[0] !== resolvedCode) {
    t0 = buildReferralState(resolvedCode);
    $[0] = resolvedCode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { getValidReferralCode };
export type { ReferralStatus, ReferralState };
export default useReferral;